import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import { EntitySelector } from '@bingads-webui-react/entity-selector';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { ItemComponent } from './components/item';
import { fixSVGClassListSupportForIE } from './shim';

export class OriginCampaignSelector extends React.Component {
  static defaultProps = {
    pageSize: 10,
    selectedItem: null,
    stringKeys: {
      emptyListContent: 'CampaignSelector_EmptyList_Content',
      listHeader: 'CampaignSelector_List_Header',
      selectEntity: 'CampaignSelector_SelectCampaign',
      selectEntities: 'CampaignSelector_SelectCampaigns',
      actionBar: 'CampaignSelector_Result_Action_Bar',
    },
    checkSelected: (selectedItem, item) => _.isEqual(selectedItem, item),
    campaign: null,
    isMultiMode: false,
    resultContainerOptions: {
      resultList: [],
      updateResultList: _.noop,
    },
    dropdownOptions: {
      toggle: _.noop,
      updatedDropdownItem: _.noop,
    },
    i18nLegacy: null,
    selectedItemsForMultiMode: [],
    onSelect: _.noop,
    ariaLabel: '',
    searchBoxAriaLabel: '',
    originCampaignSelectorOptions: {},
    messageConfig: {},
    perfMarker: null,
    enableAccountScope: false,
    accounts: [],
  }

  constructor(props) {
    super(props);
    const { i18n, i18nLegacy } = this.props;
    this.i18n = i18nLegacy || i18n;
    this.isSelectedLoaded = false;
  }

  state = {
    items: [],
    totalCount: 0,
  }

  componentDidMount() {
    if (!this.props.enableAccountScope) {
      this.fetch();
    }
    fixSVGClassListSupportForIE();

    const { isMultiMode, resultContainerOptions, selectedItemsForMultiMode } = this.props;
    if (isMultiMode
      && !_.isEmpty(selectedItemsForMultiMode)) {
      resultContainerOptions.updateResultList(selectedItemsForMultiMode);
      this.isSelectedLoaded = true;
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isMultiMode, resultContainerOptions,
      selectedItemsForMultiMode, dropdownOptions,
    } = this.props;
    if (isMultiMode
      && !this.isSelectedLoaded
      && !_.isEmpty(selectedItemsForMultiMode)) {
      resultContainerOptions.updateResultList(selectedItemsForMultiMode);
      this.isSelectedLoaded = true;
    }
    if (dropdownOptions.isToggled) {
      // ensure input show up after dropdown is opened and auto focus on it
      setTimeout(() => $('.ba-campaign-selector .search-box__input').focus());
    }

    // TODO llzhang, if no acconts, clear items and totalCount
    if (this.props.enableAccountScope && prevProps.accounts.length !== this.props.accounts.length) {
      this.fetch();
    }
  }

  onSelect = (selectedItem, index) => {
    this.props.onSelect(selectedItem, index);
    if (this.props.isMultiMode) {
      this.props.resultContainerOptions.updateResultList([selectedItem]);
    } else {
      this.props.dropdownOptions.toggle();
      this.props.dropdownOptions.updatedDropdownItem(selectedItem);
    }
  }

  /**
 * will update the select result container with all items in current pageafter click
 * @returns {undefined} will call the props callback function
 */
  onSelectAllClick = () => {
    this.props.resultContainerOptions.updateResultList(this.state.items);
  }

  getRenderers() {
    const { originCampaignSelectorOptions: options } = this.props;

    const renderHeader = _.isFunction(options.renderHeader) ?
      () => options.renderHeader(this.state.totalCount) :
      this.renderHeader;

    const renderItem = _.isFunction(options.renderItem) ?
      (...args) => options.renderItem(...args) :
      this.renderItem;

    return {
      renderHeader,
      renderItem,
    };
  }

  /**
 * transform the item with the isAddedToResultList property
 * @returns {object} the transformed item
 */
  itemsAdapter() {
    const { resultContainerOptions, isMultiMode } = this.props;
    const { items } = this.state;
    const itemsAdapter = [];

    for (let i = 0; i < items.length; i += 1) {
      const newItem = { ...items[i] };
      if (isMultiMode) {
        newItem.isShowAddArrow = true;
      }
      if (this.findItemIndex(resultContainerOptions.resultList, items[i]) > -1) {
        newItem.isAddedToResultList = true;
      } else {
        newItem.isAddedToResultList = false;
      }
      itemsAdapter.push(newItem);
    }
    return itemsAdapter;
  }

  /**
  * util function: find if an item is in the list(same Id), if so, return the index
  * @param {list} list - the list to find the item
  * @param {Object} item - item to be found
  * @returns {number} index, if not found, will return -1
  */
  findItemIndex(list, item) {
    for (let i = 0; i < list.length; i += 1) {
      if (item.Id === list[i].Id) {
        return i;
      }
    }
    return -1;
  }

  fetch = ({ query = '', pageNumber = 0 } = {}) => {
    if (this.props.perfMarker) {
      this.props.perfMarker.willFetchData();
    }
    Promise.resolve(this.props.fetch({ query, pageNumber, pageSize: this.props.pageSize, accounts: this.props.accounts }))
      .then((data) => {
        if (this.props.perfMarker) {
          this.props.perfMarker.willRender();
        }
        this.setState(_.pick(data, 'items', 'totalCount'), () => {
          if (this.props.perfMarker) {
            this.props.perfMarker.done();
          }
        });
      });
  }

  renderItem = (item, index, forwardedRef) => (
    <ItemComponent
      item={item}
      index={index}
      campaign={this.props.campaign}
      forwardedRef={forwardedRef}
    />
  );

  renderEmptyList = () => (
    <div className="empty-content">
      {this.i18n.getString(this.props.stringKeys.emptyListContent)}
    </div>
  )

  renderHeader = () => (
    <div className="panel-heading">
      <h4 className="panel-title">
        {this.i18n.getString(this.props.stringKeys.listHeader, {
          itemCount: this.state.totalCount,
        })}
      </h4>
    </div>
  )

  /**
  * render action bar: select all
  * @returns {object} return the action bar component
  */
  renderActionBar = () => (
    <div
      className="select-all-content"
      onClick={this.onSelectAllClick}
      onKeyDown={submitEvent(() => this.onSelectAllClick())}
      role="menuitem"
      tabIndex={0}
    >
      <span>{this.i18n.getString(this.props.stringKeys.actionBar)}</span>
      <span className="enabled arrow-button" />
    </div>
  )

  render() {
    const { isMultiMode, dropdownOptions } = this.props;
    const items = isMultiMode ? this.itemsAdapter() : this.state.items;
    let enableOverflowTooltip = dropdownOptions.isToggled;
    if (enableOverflowTooltip === undefined) {
      enableOverflowTooltip = true;
    }

    const { renderHeader, renderItem } = this.getRenderers();

    return (
      <EntitySelector
        onFetch={this.fetch}
        renderHeader={renderHeader}
        renderItem={renderItem}
        renderEmptyList={this.renderEmptyList}
        renderActionBar={this.props.isMultiMode ? this.renderActionBar : undefined}
        onSelect={this.onSelect}
        selectedItem={this.props.selectedItem}
        items={items}
        totalCount={this.state.totalCount}
        i18n={this.i18n}
        pageSize={this.props.pageSize}
        checkSelected={this.props.checkSelected}
        enableArrowKeysSupport
        ariaLabel={this.props.ariaLabel}
        searchBoxAriaLabel={this.props.searchBoxAriaLabel}
        enableOverflowTooltip={enableOverflowTooltip}
        messageConfig={this.props.messageConfig}
      />
    );
  }
}

OriginCampaignSelector.propTypes = {
  /**
   * item count per page
   */
  pageSize: PropTypes.number,
  /**
   * function to fetch items
   */
  fetch: PropTypes.func.isRequired,
  /**
   * callback to pass selected item and it's index outside
   */
  onSelect: PropTypes.func,
  /**
   * selected item
   */
  selectedItem: PropTypes.objectOf(PropTypes.any),
  /**
   * i18n for localization
   */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * i18n for localization
   */
  i18nLegacy: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }),
  /**
   * keys for customized strings
   */
  stringKeys: PropTypes.objectOf(PropTypes.string),
  /**
   * Used to check whether an item is selected.
   *
   * @param {Object} selectedItem - selected item
   * @param {Object} item - single data in the list
   * @return {boolean} - whether current item is selected
   */
  checkSelected: PropTypes.func,
  /**
   * judge whhether campaign selector is used as adgroup selector
   */
  campaign: PropTypes.objectOf(PropTypes.any),
  isMultiMode: PropTypes.bool,
  /**
  * the initial selected item list for multi mode
  */
  selectedItemsForMultiMode: PropTypes.arrayOf(PropTypes.any),
  resultContainerOptions: PropTypes.shape({
    resultList: PropTypes.arrayOf(PropTypes.any),
    updateResultList: PropTypes.func,
  }),
  dropdownOptions: PropTypes.shape({
    toggle: PropTypes.func,
    updatedDropdownItem: PropTypes.func,
    isToggled: PropTypes.bool,
  }),
  /**
   * aria label of list selector
   */
  ariaLabel: PropTypes.string,
  /**
   * aria label of search box  inputor
   */
  searchBoxAriaLabel: PropTypes.string,
  /**
   * customize OriginCampaignSelector
   */
  originCampaignSelectorOptions: PropTypes.shape({}),
  /**
   * message bar configuration
   */
  messageConfig: PropTypes.shape({}),
  perfMarker: perfMarkerPropTypes,
  enableAccountScope: PropTypes.bool,
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
};
